module.exports = __webpack_public_path__ + "static/media/select_down.761d091b.svg";